import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options   raw-material options from buildRawMaterialTypeOptions
 *   required  the declaration form requires it; the contract/shipment forms do not
 *   disabled  locks the control
 */
export const RawMaterialTypeField = ({
  options = EMPTY_LIST,
  required = false,
  disabled = false,
}) => {
  const t = useTranslations();

  return (
    <Field name="rawMaterialType" required={required}>
      {({ id, name, value, onChange, onBlur, status, message, required: isRequired }) => (
        <Dropdown
          searchable
          id={id}
          name={name}
          label={required ? t('FIELD_TYPE_OF_RAW_MATERIAL') : t('FORM_RAW_MATERIAL_TYPE')}
          placeholder={t('FORM_RAW_MATERIAL_TYPE_PLACEHOLDER')}
          searchPlaceholder={t('COMMON_SEARCH_RAW_MATERIAL')}
          emptyMessage={t('COMMON_NO_OPTIONS')}
          noResultsMessage={t('COMMON_NO_MATCHES')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={isRequired}
          disabled={disabled}
          options={options}
        />
      )}
    </Field>
  );
};
